import { createState } from "states/createState";

export const { listState, currentIdState, itemState } =
  createState<ArticleView>({ name: "article", getId: ({ _id }) => _id });
